/**
 * Load standalone startup after Module Federation initializes shared modules.
 *
 * @author guido.porcaro
 * @aiAuthor gpt-6-sol-flex
 */
import('./Bootstrap');
